import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

import { SettingsProvider } from '@/context/SettingsContext';
import { PublicLayout } from '@/components/layout/PublicLayout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Trips from '@/pages/Trips';
import TripDetail from '@/pages/TripDetail';
import Shop from '@/pages/Shop';
import Team from '@/pages/Team';
import Contact from '@/pages/Contact';
import SDICourses from '@/pages/SDICourses';
import TDICourses from '@/pages/TDICourses';
import FRTICourses from '@/pages/FRTICourses';
import AdminLogin from '@/pages/admin/Login';
import AdminLayout from '@/pages/admin/AdminLayout';
import SettingsTab from '@/pages/admin/SettingsTab';
import TripsTab from '@/pages/admin/TripsTab';
import ProductsTab from '@/pages/admin/ProductsTab';
import TeamTab from '@/pages/admin/TeamTab';
import CoursesTab from '@/pages/admin/CoursesTab';
import BookingsTab from '@/pages/admin/BookingsTab';
import PromoCodesTab from '@/pages/admin/PromoCodesTab';

function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <SettingsProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<SettingsTab />} />
            <Route path="bookings" element={<BookingsTab />} />
            <Route path="trips" element={<TripsTab />} />
            <Route path="shop" element={<ProductsTab />} />
            <Route path="promos" element={<PromoCodesTab />} />
            <Route path="team" element={<TeamTab />} />
            <Route path="courses" element={<CoursesTab />} />
          </Route>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/trips/:slug" element={<TripDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
            <Route path="/courses" element={<Navigate to="/courses/sdi" replace />} />
            <Route path="/courses/sdi" element={<SDICourses />} />
            <Route path="/courses/tdi" element={<TDICourses />} />
            <Route path="/courses/frti" element={<FRTICourses />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
